// extracted by mini-css-extract-plugin
export var label = "_d5-2";
export var slideContainer = "_d5-0";
export var slider = "_d5-1";